var Mustache = require("mustache")

export default class IcStatusDoc {
    constructor() {
        //eslint-disable-next-line
        this.json = `
{"pageSize":"LETTER","pageMargins":[45,55,45,0],"content":[{"text":"Declaration of Independent Contractor Status Form","bold":true,"fontSize":18,"margin":[0,0,0,14],"color":"#00567d"},{"text":["According to the Colorado Workers’ Compensation Act, a person is an independent contractor, not an employee, if ",{"text":"both","italics":true}," of the following statements are true."],"style":"para"},{"text":"1.  He/she is free from control and direction in the performance of the service (unless control is exercised under the requirement of any state or federal statute or regulation).","style":"para"},{"text":"2. He/she is customarily engaged in an independent trade, occupation, profession, or business related to the services performed.","style":"para"},{"text":"The Colorado Workers’ Compensation Act also outlines nine criteria (listed on page 2) to help determine whether or not the above statements are true. For an individual to be considered an independent contractor, he/she must meet only those criteria that are appropriate to the situation. He/she does not need to meet all of the nine criteria.","style":"para"},{"text":["This Declaration of Independent Contractor Status Form documents the business relationship as defined in the Colorado Workers’ Compensation Act. ",{"text":"It is the responsibility of our policyholders and their independent contractor(s) to correctly and truthfully complete this form. ","italics":true},"Pinnacol Assurance will accept this form only when it is initialed where applicable, signed, and notarized by both parties. If you do not understand this form, do not sign it."],"style":"para"},{"text":"If you have any questions, please contact a member of Pinnacol’s customer service team at 303.361.4000 or 800.873.7242.","style":"para"},{"text":"Please make copies of this form as needed. You should complete this form only once for each independent contractor for the lifetime of your Pinnacol policy or until the business relationship changes. ","style":"para","bold":true},{"canvas":[{"type":"rect","x":0,"y":-8,"w":525,"h":125,"color":"#ccdde5"}],"margin":[0,15,0,0]},{"text":"This form is not valid unless a signed and notarized copy of the form is returned to Pinnacol Assurance. Keep the original for your records and send a copy to Pinnacol. You can do this the following ways:","style":"para","bold":true,"fontSize":10.5,"margin":[13,-120,12,10]},{"ul":[{"text":[{"text":"EMail: ","bold":true}," customer_service@pinnacol.com"],"style":"para"},{"text":[{"text":"Mail: ","bold":true}," Pinnacol Assurance\\n","P.O. Box 469011\\n","Denver, CO 80246-9011"],"style":"para"},{"text":[{"text":"Fax: ","bold":true}," 303.361.5000"],"style":"para"}],"margin":[13,0,0,10]},{"canvas":[{"type":"rect","x":0,"y":0,"w":525,"h":30,"color":"#00567d"}],"margin":[0,263,0,0]},{"text":"Page 1 of 3   ZAUCCIF007  03/17","fontSize":8,"color":"white","absolutePosition":{"x":60,"y":758}},{"image":"logo","width":60,"absolutePosition":{"x":500,"y":754}},{"text":"Declaration of Independent Contractor Status Form","bold":true,"fontSize":18,"margin":[0,0,0,14],"color":"#00567d"},{"text":["We certify ",{"text":"UNDER PENALTY OF PERJURY","bold":true}," that (insert",{"text":" contractor’s name and trade name","bold":true}," below):"],"style":"para"},{"columns":[{"text":"Name:","width":253},{"text":"Trade Name:"}]},{"canvas":[{"type":"line","x1":30,"y1":0,"x2":250,"y2":0,"lineWidth":0.5}]},{"canvas":[{"type":"line","x1":312,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":["Performing (type of work):","   courier"],"style":"spacer"},{"canvas":[{"type":"line","x1":118,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":"Federal Employer Identification #:","style":"spacer"},{"canvas":[{"type":"line","x1":150,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":"Address:","style":"spacer"},{"canvas":[{"type":"line","x1":43,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":"Phone:","style":"spacer"},{"canvas":[{"type":"line","x1":35,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":"{{{userName}}}","absolutePosition":{"x":80,"y":109}},{"text":"{{{companyName}}}","absolutePosition":{"x":360,"y":109}},{"text":"{{{fein}}}","absolutePosition":{"x":197,"y":153}},{"text":"{{{address}}}","absolutePosition":{"x":90,"y":175}},{"text":"{{{phone}}}","absolutePosition":{"x":80,"y":197}},{"text":["Is an independent contractor (",{"text":"IC","bold":true},") and is not an employee of the following policyholder (",{"text":"PH","bold":true},"):"],"style":"spacer"},{"text":["Policyholder's name:   ","Elite Logistics, Inc."],"style":"spacer"},{"canvas":[{"type":"line","x1":94,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":["Address:","   PO Box 567, Littleton, CO 80160"],"style":"spacer"},{"canvas":[{"type":"line","x1":43,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"columns":[{"text":"Policy #:   4135231","width":253},{"text":"Phone:   720-672-0239"}],"style":"spacer"},{"canvas":[{"type":"line","x1":38,"y1":0,"x2":250,"y2":0,"lineWidth":0.5}]},{"canvas":[{"type":"line","x1":285,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":["We also certify, by ",{"text":"OUR","bold":true}," initials ",{"text":"WHERE APPLICABLE","bold":true},", that the above business for which the above individual performs services meet the following criteria:"],"style":"spacer"},{"columns":[{"text":"IC____PH.____1.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," require the individual to work ",{"text":"ONLY ","bold":true},"for the business for whom services are performed (except that the individual may",{"text":" DECIDE ","bold":true},"to work only for the business for a definite period);"]}],"style":"spacer"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":337}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":340}},{"columns":[{"text":"IC____PH.____2.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," establish a quality standard for the individual (except that the business may provide plans and specifications regarding work but cannot oversee the actual work or instruct the individual as to how work will be performed);"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":378}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":381}},{"columns":[{"text":"IC____PH.____3.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," pay the individual a salary or an hourly rate instead of a fixed or contract rate;"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":419}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":422}},{"columns":[{"text":"IC____PH.____4.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," terminate the work or the service provided during the contract period unless the individual violates the terms of the contract or fails to produce a result that meets the specifications of the contract;"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":449}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":452}},{"columns":[{"text":"IC____PH.____5.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," provide more than minimal training for the individual;"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":490}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":492}},{"columns":[{"text":"IC____PH.____6.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," provide tools or benefits to the individual (except that materials and equipment may be supplied);"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":508}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":510}},{"columns":[{"text":"IC____PH.____7.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," dictate the time of performance (except that a completion schedule and a range of agreeable work hours may be established);"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":537}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":539}},{"columns":[{"text":"IC____PH.____8.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," pay the individual personally instead of making payment or checks payable to the trade or business name of the individual;"]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":566}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":569}},{"columns":[{"text":"IC____PH.____9.","width":80,"bold":true},{"text":["The business ",{"text":"DOES NOT","bold":true}," combine the business operations in any way with the individual’s business operations instead of maintaining all such operations separately and distinctly."]}],"style":"spacer2"},{"image":"initials","fit":[12,12],"absolutePosition":{"x":90,"y":596}},{"image":"userinit","fit":[12,12],"absolutePosition":{"x":56,"y":599}},{"canvas":[{"type":"rect","x":0,"y":15,"w":525,"h":55,"color":"#ccdde5"}],"margin":[0,15,0,0]},{"text":"Do not forget to complete page 3 of this form, which contains the Certification by the Independent Contractor. This certification must be signed and notarized.","style":"para","bold":true,"fontSize":10.5,"margin":[13,-40,12,10],"color":"#00567d"},{"canvas":[{"type":"rect","x":0,"y":0,"w":525,"h":30,"color":"#00567d"}],"margin":[0,50,0,0]},{"text":"Page 2 of 3   ZAUCCIF007  03/17","fontSize":8,"color":"white","absolutePosition":{"x":60,"y":762}},{"image":"logo","width":60,"absolutePosition":{"x":500,"y":757}},{"text":"Certification by Independent Contractor","bold":true,"decoration":"underline","decorationColor":"#00567d","fontSize":12,"margin":[0,0,0,14],"color":"#00567d"},{"text":"The independent contractor understands that he/she:","bold":true,"fontSize":12,"margin":[0,0,0,14],"color":"#00567d"},{"ul":[{"text":"Will not be entitled to any workers’ compensation benefits in the event of injury.","style":"spacer3"},{"text":"Is obligated to pay all federal and state income tax on all money earned while performing services for the business.","style":"spacer3"},{"text":"Is required to provide workers’ compensation insurance for all workers that he/she hires.","style":"spacer3"}],"bold":true,"fontSize":12},{"columns":[{"text":"Signature:","width":275},{"text":"Title:"}],"margin":[0,10,0,0]},{"canvas":[{"type":"line","x1":50,"y1":0,"x2":270,"y2":0,"lineWidth":0.5}]},{"canvas":[{"type":"line","x1":300,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":[{"text":"Last four digits of Social Security #: XXX-XX-___________"},{"text":"(please do not provide us with your complete Social Security #)","italics":true}],"margin":[0,10,0,0]},{"text":"{{{title}}}","absolutePosition":{"x":348,"y":189}},{"text":"{{{ssn}}}","absolutePosition":{"x":242,"y":210}},{"text":"Acceptance of the Independent Contractor named on this form does not change any party’s responsibility under the Workers’ Compensation Act. If individuals or organizations hired or contracted by the Independent Contractor are not covered by other workers’ compensation insurance, the policyholder specified on this form will be charged premium for coverage of those individuals or organizations.","margin":[0,10,0,10]},{"text":"Notary Public","bold":true,"fontSize":12,"margin":[0,0,0,10],"color":"#00567d"},{"columns":[{"text":"State of Colorado","width":90},{"text":")"}]},{"columns":[{"text":"","width":90},{"text":") §§"}],"style":"spacer2"},{"columns":[{"text":"County of","width":90},{"text":")_______________________________________________________"}],"style":"spacer2"},{"columns":[{"text":"Subscribed and sworn before me by:","width":165},{"text":"_______________________________________"}],"style":"spacer2"},{"text":"This __________ day of ___________________________________ , _________________","style":"spacer2"},{"text":"Commission expires:  ______________________________________________________","style":"spacer2"},{"text":"Signature:  _________________________________________________________________","style":"spacer2","bold":true},{"canvas":[{"type":"line","x1":0,"y1":15,"x2":520,"y2":15,"lineWidth":2,"lineColor":"#00567d"}]},{"text":"Certification By Pinnacol Policyholder","bold":true,"decoration":"underline","decorationColor":"#00567d","fontSize":12,"margin":[0,15,0,14],"color":"#00567d"},{"text":"I certify that I am authorized by the business listed above to state that all of the information on this form is true and accurate. I understand that if the above person does not qualify for independent contractor status, the proper premium can be assessed.","style":"para"},{"columns":[{"text":"Signature:","width":275},{"text":"Title:   President/Owner"}],"margin":[0,10,0,0]},{"canvas":[{"type":"line","x1":50,"y1":0,"x2":270,"y2":0,"lineWidth":0.5}]},{"canvas":[{"type":"line","x1":300,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":[{"text":"Policy # "},{"text":"or ","bold":true},{"text":"Federal Employer Identification #:   4135231"}],"margin":[0,10,0,0]},{"canvas":[{"type":"line","x1":200,"y1":0,"x2":520,"y2":0,"lineWidth":0.5}]},{"text":"Notary Public","bold":true,"fontSize":12,"margin":[0,12,0,10],"color":"#00567d"},{"columns":[{"text":"State of Colorado","width":90},{"text":")"}]},{"columns":[{"text":"","width":90},{"text":") §§"}],"style":"spacer2"},{"columns":[{"text":"County of","width":90},{"text":")_______________________________________________________"}],"style":"spacer2"},{"columns":[{"text":"Subscribed and sworn before me by:","width":165},{"text":"_______________________________________"}],"style":"spacer2"},{"text":"This __________ day of ___________________________________ , _________________","style":"spacer2"},{"text":"Commission expires:  ______________________________________________________","style":"spacer2"},{"text":"Signature:  _________________________________________________________________","style":"spacer2","bold":true},{"canvas":[{"type":"rect","x":0,"y":0,"w":525,"h":30,"color":"#00567d"}],"margin":[0,20,0,0]},{"text":"Page 3 of 3   ZAUCCIF007  03/17","fontSize":8,"color":"white","absolutePosition":{"x":60,"y":762}},{"image":"logo","width":60,"absolutePosition":{"x":500,"y":757}}],"defaultStyle":{"fontSize":10,"margin":[0,0,0,9]},"styles":{"spacer":{"margin":[0,10,0,0]},"spacer2":{"margin":[0,6,0,0]},"spacer3":{"margin":[0,4,0,0]},"para":{"margin":[0,0,0,8]}},"images":{"logo":"data:image/png;base64,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","initials":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAACxElEQVQ4T2NkwAH+//8fCpJiZGRcDVPy//9/XgYGhloGBoYkBgaGjwwMDAWM6Pr///+vx8DA0MHAwODKwMDAApV/y8DAMIuBgWH983efJwf0Ljf78ev3t/Zot0C4AVDTixkYGNLm7jsnnjJzAxOy4WkuJk9mpvrVX3zwotq/e5mSk7bCnXlZQY7IBjRdffKqyLtjCffD1x8YjJSkfq3MC5n2/fffSN/OJeJJTsYn6oIdluy5fK/JtWWB0IKsoFUJDobhYAP+//+v9ez959kBXcvMNWVEP/3+909AhJfzQ3uk65e0WZtkv/749aE/0SteUURAZ/bes3VNaw+wTIj3bAqx0G6Cu2DW3jMZC/afi+qIcpWInbpOtTvGnaF381GGFx+/MGyrjP2jJS16m4GB4UP50l3mt569/dwV7R6qJi28G9kLsQwMDJlz9501S5m5kRlb5OR7Wv589fkrGwcry715GQEOjIyMT2BeUHr69uOc4L6VjifvPGEIsdD+PjvNf50AN8chkEFXHr1q9OlcLJHkZPRz7r7zbHF2+gebw51BFibADADFb+GrT1+zfTuXinoZqB6rD3UMAsX3q09f8/06l0rIivB/T3Iw+p8+ZxPHjBTfCV6Ganz7r96PRfZCwt7L9/oSp6/nn5sZMNtVV1n12tPXdl7ti1kEuTi+b66IObzjwm2nGbtO/99UHn3y1rM3Fo5N81mQXTChfOnOhMdvPzFMSvT+m79gG+uyI5cYPAxUn89M8cvn52EPzZy9Ofjey/dMfiYaDNUr9jAEm2ufZvz//783AwPDhDefv6n4dCxhAIUBCEgL8v2enurb52eiUfH//3+xj99/TEmbucl/1fErbCD5Qm+rjX1xHrEgA/Q2nL42J7BnhamrrvIfBTGBZ7PS/DsYGRmnI8fE////3UGBxsDA8IWBgWEBIyPjUZA8AJQ5NTJczp5GAAAAAElFTkSuQmCC","userinit":"{{{userInitials}}}"}}        `

        /*
        this.formatted =
`
{
	"pageSize": "LETTER",
	"pageMargins": [
		45,
		55,
		45,
		0
	],
	"content": [{
			"text": "Declaration of Independent Contractor Status Form",
			"bold": true,
			"fontSize": 18,
			"margin": [
				0,
				0,
				0,
				14
			],
			"color": "#00567d"
		},
		{
			"text": [
				"According to the Colorado Workers’ Compensation Act, a person is an independent contractor, not an employee, if ",
				{
					"text": "both",
					"italics": true
				},
				" of the following statements are true."
			],
			"style": "para"
		},
		{
			"text": "1.  He/she is free from control and direction in the performance of the service (unless control is exercised under the requirement of any state or federal statute or regulation).",
			"style": "para"
		},
		{
			"text": "2. He/she is customarily engaged in an independent trade, occupation, profession, or business related to the services performed.",
			"style": "para"
		},
		{
			"text": "The Colorado Workers’ Compensation Act also outlines nine criteria (listed on page 2) to help determine whether or not the above statements are true. For an individual to be considered an independent contractor, he/she must meet only those criteria that are appropriate to the situation. He/she does not need to meet all of the nine criteria.",
			"style": "para"
		},
		{
			"text": [
				"This Declaration of Independent Contractor Status Form documents the business relationship as defined in the Colorado Workers’ Compensation Act. ",
				{
					"text": "It is the responsibility of our policyholders and their independent contractor(s) to correctly and truthfully complete this form. ",
					"italics": true
				},
				"Pinnacol Assurance will accept this form only when it is initialed where applicable, signed, and notarized by both parties. If you do not understand this form, do not sign it."
			],
			"style": "para"
		},
		{
			"text": "If you have any questions, please contact a member of Pinnacol’s customer service team at 303.361.4000 or 800.873.7242.",
			"style": "para"
		},
		{
			"text": "Please make copies of this form as needed. You should complete this form only once for each independent contractor for the lifetime of your Pinnacol policy or until the business relationship changes. ",
			"style": "para",
			"bold": true
		},
		{
			"canvas": [{
				"type": "rect",
				"x": 0,
				"y": -8,
				"w": 525,
				"h": 125,
				"color": "#ccdde5"
			}],
			"margin": [
				0,
				15,
				0,
				0
			]
		},
		{
			"text": "This form is not valid unless a signed and notarized copy of the form is returned to Pinnacol Assurance. Keep the original for your records and send a copy to Pinnacol. You can do this the following ways:",
			"style": "para",
			"bold": true,
			"fontSize": 10.5,
			"margin": [
				13,
				-120,
				12,
				10
			]
		},
		{
			"ul": [{
					"text": [{
							"text": "EMail: ",
							"bold": true
						},
						" customer_service@pinnacol.com"
					],
					"style": "para"
				},
				{
					"text": [{
							"text": "Mail: ",
							"bold": true
						},
						" Pinnacol Assurance\\n",
						"P.O. Box 469011\\n",
						"Denver, CO 80246-9011"
					],
					"style": "para"
				},
				{
					"text": [{
							"text": "Fax: ",
							"bold": true
						},
						" 303.361.5000"
					],
					"style": "para"
				}
			],
			"margin": [
				13,
				0,
				0,
				10
			]
		},
		{
			"canvas": [{
				"type": "rect",
				"x": 0,
				"y": 0,
				"w": 525,
				"h": 30,
				"color": "#00567d"
			}],
			"margin": [
				0,
				263,
				0,
				0
			]
		},
		{
			"text": "Page 1 of 3   ZAUCCIF007  03/17",
			"fontSize": 8,
			"color": "white",
			"absolutePosition": {
				"x": 60,
				"y": 758
			}
		},
		{
			"image": "logo",
			"width": 60,
			"absolutePosition": {
				"x": 500,
				"y": 754
			}
		},
		{
			"text": "Declaration of Independent Contractor Status Form",
			"bold": true,
			"fontSize": 18,
			"margin": [
				0,
				0,
				0,
				14
			],
			"color": "#00567d"
		},
		{
			"text": [
				"We certify ",
				{
					"text": "UNDER PENALTY OF PERJURY",
					"bold": true
				},
				" that (insert",
				{
					"text": " contractor’s name and trade name",
					"bold": true
				},
				" below):"
			],
			"style": "para"
		},
		{
			"columns": [{
					"text": "Name:",
					"width": 253
				},
				{
					"text": "Trade Name:"
				}
			]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 30,
				"y1": 0,
				"x2": 250,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 312,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": [
				"Performing (type of work):",
				"   courier"
			],
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 118,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": "Federal Employer Identification #:",
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 150,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": "Address:",
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 43,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": "Phone:",
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 35,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": "{{{userName}}}",
			"absolutePosition": {
				"x": 80,
				"y": 109
			}
		},
		{
			"text": "{{{companyName}}}",
			"absolutePosition": {
				"x": 360,
				"y": 109
			}
		},
		{
			"text": "{{{fein}}}",
			"absolutePosition": {
				"x": 197,
				"y": 153
			}
		},
		{
			"text": "{{{address}}}",
			"absolutePosition": {
				"x": 90,
				"y": 175
			}
		},
		{
			"text": "{{{phone}}}",
			"absolutePosition": {
				"x": 80,
				"y": 197
			}
		},
		{
			"text": [
				"Is an independent contractor (",
				{
					"text": "IC",
					"bold": true
				},
				") and is not an employee of the following policyholder (",
				{
					"text": "PH",
					"bold": true
				},
				"):"
			],
			"style": "spacer"
		},
		{
			"text": [
				"Policyholder's name:   ",
				"Elite Logistics, Inc."
			],
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 94,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": [
				"Address:",
				"   PO Box 567, Littleton, CO 80160"
			],
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 43,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"columns": [{
					"text": "Policy #:   4135231",
					"width": 253
				},
				{
					"text": "Phone:   720-672-0239"
				}
			],
			"style": "spacer"
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 38,
				"y1": 0,
				"x2": 250,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 285,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": [
				"We also certify, by ",
				{
					"text": "OUR",
					"bold": true
				},
				" initials ",
				{
					"text": "WHERE APPLICABLE",
					"bold": true
				},
				", that the above business for which the above individual performs services meet the following criteria:"
			],
			"style": "spacer"
		},
		{
			"columns": [{
					"text": "IC____PH.____1.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" require the individual to work ",
						{
							"text": "ONLY ",
							"bold": true
						},
						"for the business for whom services are performed (except that the individual may",
						{
							"text": " DECIDE ",
							"bold": true
						},
						"to work only for the business for a definite period);"
					]
				}
			],
			"style": "spacer"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 337
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 340
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____2.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" establish a quality standard for the individual (except that the business may provide plans and specifications regarding work but cannot oversee the actual work or instruct the individual as to how work will be performed);"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 378
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 381
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____3.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" pay the individual a salary or an hourly rate instead of a fixed or contract rate;"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 419
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 422
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____4.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" terminate the work or the service provided during the contract period unless the individual violates the terms of the contract or fails to produce a result that meets the specifications of the contract;"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 449
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 452
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____5.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" provide more than minimal training for the individual;"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 490
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 492
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____6.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" provide tools or benefits to the individual (except that materials and equipment may be supplied);"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 508
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 510
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____7.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" dictate the time of performance (except that a completion schedule and a range of agreeable work hours may be established);"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 537
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 539
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____8.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" pay the individual personally instead of making payment or checks payable to the trade or business name of the individual;"
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 566
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 569
			}
		},
		{
			"columns": [{
					"text": "IC____PH.____9.",
					"width": 80,
					"bold": true
				},
				{
					"text": [
						"The business ",
						{
							"text": "DOES NOT",
							"bold": true
						},
						" combine the business operations in any way with the individual’s business operations instead of maintaining all such operations separately and distinctly."
					]
				}
			],
			"style": "spacer2"
		},
		{
			"image": "initials",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 90,
				"y": 596
			}
		},
		{
			"image": "userinit",
			"fit": [
				12,
				12
			],
			"absolutePosition": {
				"x": 56,
				"y": 599
			}
		},
		{
			"canvas": [{
				"type": "rect",
				"x": 0,
				"y": 15,
				"w": 525,
				"h": 55,
				"color": "#ccdde5"
			}],
			"margin": [
				0,
				15,
				0,
				0
			]
		},
		{
			"text": "Do not forget to complete page 3 of this form, which contains the Certification by the Independent Contractor. This certification must be signed and notarized.",
			"style": "para",
			"bold": true,
			"fontSize": 10.5,
			"margin": [
				13,
				-40,
				12,
				10
			],
			"color": "#00567d"
		},
		{
			"canvas": [{
				"type": "rect",
				"x": 0,
				"y": 0,
				"w": 525,
				"h": 30,
				"color": "#00567d"
			}],
			"margin": [
				0,
				50,
				0,
				0
			]
		},
		{
			"text": "Page 2 of 3   ZAUCCIF007  03/17",
			"fontSize": 8,
			"color": "white",
			"absolutePosition": {
				"x": 60,
				"y": 762
			}
		},
		{
			"image": "logo",
			"width": 60,
			"absolutePosition": {
				"x": 500,
				"y": 757
			}
		},
		{
			"text": "Certification by Independent Contractor",
			"bold": true,
			"decoration": "underline",
			"decorationColor": "#00567d",
			"fontSize": 12,
			"margin": [
				0,
				0,
				0,
				14
			],
			"color": "#00567d"
		},
		{
			"text": "The independent contractor understands that he/she:",
			"bold": true,
			"fontSize": 12,
			"margin": [
				0,
				0,
				0,
				14
			],
			"color": "#00567d"
		},
		{
			"ul": [{
					"text": "Will not be entitled to any workers’ compensation benefits in the event of injury.",
					"style": "spacer3"
				},
				{
					"text": "Is obligated to pay all federal and state income tax on all money earned while performing services for the business.",
					"style": "spacer3"
				},
				{
					"text": "Is required to provide workers’ compensation insurance for all workers that he/she hires.",
					"style": "spacer3"
				}
			],
			"bold": true,
			"fontSize": 12
		},
		{
			"columns": [{
					"text": "Signature:",
					"width": 275
				},
				{
					"text": "Title:"
				}
			],
			"margin": [
				0,
				10,
				0,
				0
			]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 50,
				"y1": 0,
				"x2": 270,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 300,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": [{
					"text": "Last four digits of Social Security #: XXX-XX-___________"
				},
				{
					"text": "(please do not provide us with your complete Social Security #)",
					"italics": true
				}
			],
			"margin": [
				0,
				10,
				0,
				0
			]
		},
		{
			"text": "{{{title}}}",
			"absolutePosition": {
				"x": 348,
				"y": 189
			}
		},
		{
			"text": "{{{ssn}}}",
			"absolutePosition": {
				"x": 242,
				"y": 210
			}
		},
		{
			"text": "Acceptance of the Independent Contractor named on this form does not change any party’s responsibility under the Workers’ Compensation Act. If individuals or organizations hired or contracted by the Independent Contractor are not covered by other workers’ compensation insurance, the policyholder specified on this form will be charged premium for coverage of those individuals or organizations.",
			"margin": [
				0,
				10,
				0,
				10
			]
		},
		{
			"text": "Notary Public",
			"bold": true,
			"fontSize": 12,
			"margin": [
				0,
				0,
				0,
				10
			],
			"color": "#00567d"
		},
		{
			"columns": [{
					"text": "State of Colorado",
					"width": 90
				},
				{
					"text": ")"
				}
			]
		},
		{
			"columns": [{
					"text": "",
					"width": 90
				},
				{
					"text": ") §§"
				}
			],
			"style": "spacer2"
		},
		{
			"columns": [{
					"text": "County of",
					"width": 90
				},
				{
					"text": ")_______________________________________________________"
				}
			],
			"style": "spacer2"
		},
		{
			"columns": [{
					"text": "Subscribed and sworn before me by:",
					"width": 165
				},
				{
					"text": "_______________________________________"
				}
			],
			"style": "spacer2"
		},
		{
			"text": "This __________ day of ___________________________________ , _________________",
			"style": "spacer2"
		},
		{
			"text": "Commission expires:  ______________________________________________________",
			"style": "spacer2"
		},
		{
			"text": "Signature:  _________________________________________________________________",
			"style": "spacer2",
			"bold": true
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 0,
				"y1": 15,
				"x2": 520,
				"y2": 15,
				"lineWidth": 2,
				"lineColor": "#00567d"
			}]
		},
		{
			"text": "Certification By Pinnacol Policyholder",
			"bold": true,
			"decoration": "underline",
			"decorationColor": "#00567d",
			"fontSize": 12,
			"margin": [
				0,
				15,
				0,
				14
			],
			"color": "#00567d"
		},
		{
			"text": "I certify that I am authorized by the business listed above to state that all of the information on this form is true and accurate. I understand that if the above person does not qualify for independent contractor status, the proper premium can be assessed.",
			"style": "para"
		},
		{
			"columns": [{
					"text": "Signature:",
					"width": 275
				},
				{
					"text": "Title:   President/Owner"
				}
			],
			"margin": [
				0,
				10,
				0,
				0
			]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 50,
				"y1": 0,
				"x2": 270,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 300,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": [{
					"text": "Policy # "
				},
				{
					"text": "or ",
					"bold": true
				},
				{
					"text": "Federal Employer Identification #:   4135231"
				}
			],
			"margin": [
				0,
				10,
				0,
				0
			]
		},
		{
			"canvas": [{
				"type": "line",
				"x1": 200,
				"y1": 0,
				"x2": 520,
				"y2": 0,
				"lineWidth": 0.5
			}]
		},
		{
			"text": "Notary Public",
			"bold": true,
			"fontSize": 12,
			"margin": [
				0,
				12,
				0,
				10
			],
			"color": "#00567d"
		},
		{
			"columns": [{
					"text": "State of Colorado",
					"width": 90
				},
				{
					"text": ")"
				}
			]
		},
		{
			"columns": [{
					"text": "",
					"width": 90
				},
				{
					"text": ") §§"
				}
			],
			"style": "spacer2"
		},
		{
			"columns": [{
					"text": "County of",
					"width": 90
				},
				{
					"text": ")_______________________________________________________"
				}
			],
			"style": "spacer2"
		},
		{
			"columns": [{
					"text": "Subscribed and sworn before me by:",
					"width": 165
				},
				{
					"text": "_______________________________________"
				}
			],
			"style": "spacer2"
		},
		{
			"text": "This __________ day of ___________________________________ , _________________",
			"style": "spacer2"
		},
		{
			"text": "Commission expires:  ______________________________________________________",
			"style": "spacer2"
		},
		{
			"text": "Signature:  _________________________________________________________________",
			"style": "spacer2",
			"bold": true
		},
		{
			"canvas": [{
				"type": "rect",
				"x": 0,
				"y": 0,
				"w": 525,
				"h": 30,
				"color": "#00567d"
			}],
			"margin": [
				0,
				20,
				0,
				0
			]
		},
		{
			"text": "Page 3 of 3   ZAUCCIF007  03/17",
			"fontSize": 8,
			"color": "white",
			"absolutePosition": {
				"x": 60,
				"y": 762
			}
		},
		{
			"image": "logo",
			"width": 60,
			"absolutePosition": {
				"x": 500,
				"y": 757
			}
		}
	],
	"defaultStyle": {
		"fontSize": 10,
		"margin": [
			0,
			0,
			0,
			9
		]
	},
	"styles": {
		"spacer": {
			"margin": [
				0,
				10,
				0,
				0
			]
		},
		"spacer2": {
			"margin": [
				0,
				6,
				0,
				0
			]
		},
		"spacer3": {
			"margin": [
				0,
				4,
				0,
				0
			]
		},
		"para": {
			"margin": [
				0,
				0,
				0,
				8
			]
		}
	},
	"images": {
		"logo": "data:image/png;base64,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",
		"initials": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAACxElEQVQ4T2NkwAH+//8fCpJiZGRcDVPy//9/XgYGhloGBoYkBgaGjwwMDAWM6Pr///+vx8DA0MHAwODKwMDAApV/y8DAMIuBgWH983efJwf0Ljf78ev3t/Zot0C4AVDTixkYGNLm7jsnnjJzAxOy4WkuJk9mpvrVX3zwotq/e5mSk7bCnXlZQY7IBjRdffKqyLtjCffD1x8YjJSkfq3MC5n2/fffSN/OJeJJTsYn6oIdluy5fK/JtWWB0IKsoFUJDobhYAP+//+v9ez959kBXcvMNWVEP/3+909AhJfzQ3uk65e0WZtkv/749aE/0SteUURAZ/bes3VNaw+wTIj3bAqx0G6Cu2DW3jMZC/afi+qIcpWInbpOtTvGnaF381GGFx+/MGyrjP2jJS16m4GB4UP50l3mt569/dwV7R6qJi28G9kLsQwMDJlz9501S5m5kRlb5OR7Wv589fkrGwcry715GQEOjIyMT2BeUHr69uOc4L6VjifvPGEIsdD+PjvNf50AN8chkEFXHr1q9OlcLJHkZPRz7r7zbHF2+gebw51BFibADADFb+GrT1+zfTuXinoZqB6rD3UMAsX3q09f8/06l0rIivB/T3Iw+p8+ZxPHjBTfCV6Ganz7r96PRfZCwt7L9/oSp6/nn5sZMNtVV1n12tPXdl7ti1kEuTi+b66IObzjwm2nGbtO/99UHn3y1rM3Fo5N81mQXTChfOnOhMdvPzFMSvT+m79gG+uyI5cYPAxUn89M8cvn52EPzZy9Ofjey/dMfiYaDNUr9jAEm2ufZvz//783AwPDhDefv6n4dCxhAIUBCEgL8v2enurb52eiUfH//3+xj99/TEmbucl/1fErbCD5Qm+rjX1xHrEgA/Q2nL42J7BnhamrrvIfBTGBZ7PS/DsYGRmnI8fE////3UGBxsDA8IWBgWEBIyPjUZA8AJQ5NTJczp5GAAAAAElFTkSuQmCC",
		"userinit": "{{{userInitials}}}"
	}
}`
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
